import { derived, readable, writable } from 'svelte/store';
import { Workspace } from '@aymeric_henry_sr/svelte-proto/workspace_pb';
import type { EnumRole } from '../grpc/types/member';
import { persistentWritable } from '$lib/utils/persistentWritable';

export type Invitation = {
	id: string;
	role: EnumRole;
	workspaceId: string;
	workspaceName: string;
};

export const store = {
	user: {
		isLogged: persistentWritable(false, 'user.isLogged'),
		username: persistentWritable('', 'user.username'),
		id: persistentWritable('', 'user.id')
	},
	invitations: writable([] as Invitation[]),
	workspace: {
		idxWorskpaceSelected: persistentWritable(-1, 'workspace.idxWorskpaceSelected'),
		list: writable([] as Workspace[]),
		role: persistentWritable(4 as EnumRole, 'workspace.role'),
		hasSubscription: persistentWritable(false, 'workspace.hasSubscription'),
		currentWorkspace: readable(new Workspace())
	},
	credits: {
		balance: persistentWritable(0, 'credits.balance'),
		costEmail: persistentWritable(1, 'credits.costEmail'),
		costPhone: persistentWritable(10, 'credits.costPhone'),
		salesNavigator: persistentWritable(50, 'credits.salesNavigator'),
		priceId: persistentWritable('', 'credits.priceId'),
		isCustom: persistentWritable(false, 'credits.isCustom'),
		periodStartAt: persistentWritable(new Date(), 'credits.periodStartAt')
	}
};

async function setWorkspaceIdInLocalStorage(selectedWorkspace: Workspace) {
	const currentWorkspaceId = window.localStorage.getItem('workspaceId');
	const workspaceId = selectedWorkspace.getId();
	if (workspaceId && workspaceId !== currentWorkspaceId) {
		try {
			window.localStorage.setItem('workspaceId', workspaceId);
		} catch (error) {
			console.error('Error setting workspaceId in local storage', error);
		}
	}
}

store.workspace.currentWorkspace = derived(
	[store.workspace.list, store.workspace.idxWorskpaceSelected],
	([$list, $idx]) => {
		const myWorkspace = $list?.[$idx] ?? new Workspace();
		setWorkspaceIdInLocalStorage(myWorkspace);
		return myWorkspace;
	}
);

export function resetStore() {
	store.user.isLogged.set(false);
	store.user.username.set('');
	store.user.id.set('');
	store.invitations.set([]);
	store.workspace.idxWorskpaceSelected.set(-1);
	store.workspace.list.set([]);
	store.workspace.hasSubscription.set(false);
	store.workspace.role.set(4);
	store.credits.balance.set(0);
	store.credits.costEmail.set(1);
	store.credits.costPhone.set(10);
	store.credits.salesNavigator.set(50);
}
